import { createFileRoute } from '@tanstack/react-router'
import { SystemSettingsPage } from '../../../features/admin/SystemSettingsPage'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/settings')({
  component: AdminSettingsRoute,
})

/* ───── Route Component ───── */

function AdminSettingsRoute() {
  return <SystemSettingsPage />
}
